import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { TemplateDocumentGenerationPayload } from '@/domains/documents/store/types/TemplateDocumentGenerationPayload';
import type { UploadDocumentGenerationPayload } from '@/domains/documents/store/types/UploadDocumentGenerationPayload';
import type { SelectOption } from '@/features/editMode/types/selectOption';
import { generateDocumentInitialState } from '@/domains/documents/store/constants/generateDocumentSliceConstants';

const generateDocumentSlice = createSlice({
  name: 'generateDocument',
  initialState: generateDocumentInitialState,
  reducers: {
    resetDocumentGeneration: () => generateDocumentInitialState,
    generateDocumentGenerationTemplate: (state, _action: PayloadAction<TemplateDocumentGenerationPayload>) => {
      state.statuses.isGenerating = true;
    },
    uploadDocumentGeneration: (state, _action: PayloadAction<UploadDocumentGenerationPayload>) => {
      state.statuses.isUploading = true;
    },
    getDocumentGenerationClaimOptions: (state, _action: PayloadAction<string>) => {
      state.statuses.isOptionsLoading = true;
    },
    getDocumentGenerationClaimOptionsSuccess: (state, { payload }: PayloadAction<SelectOption[]>) => {
      state.statuses.isOptionsLoading = false;
      state.options.claimOptions = payload;
    },
    getDocumentGenerationClaimantOptions: (state, _action: PayloadAction<string>) => {
      state.statuses.isOptionsLoading = true;
    },
    getDocumentGenerationClaimantOptionsSuccess: (state, { payload }: PayloadAction<SelectOption[]>) => {
      state.statuses.isOptionsLoading = false;
      state.options.claimantOptions = payload;
    },
    getDocumentOptionsFailed: (state) => {
      state.statuses.isOptionsLoading = false;
    },
  },
});

export const {
  resetDocumentGeneration,
  generateDocumentGenerationTemplate,
  uploadDocumentGeneration,
  getDocumentGenerationClaimOptions,
  getDocumentGenerationClaimOptionsSuccess,
  getDocumentGenerationClaimantOptions,
  getDocumentGenerationClaimantOptionsSuccess,
  getDocumentOptionsFailed,
} = generateDocumentSlice.actions;

export const generateDocumentReducer = generateDocumentSlice.reducer;
export const generateDocumentReducerPath = generateDocumentSlice.reducerPath;
